import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

@Injectable()
export class AffiliateService {

    url: string = environment.apiUrl + '/affiliate/router';

    constructor(private http: HttpClient) {
    }

    postRouters(object: Object): Observable<any> {
        const headers = new HttpHeaders({'Content-Type': 'application/json'});
        return this.http.post(this.url, object, {headers: headers, observe: "response"}).pipe(
            catchError(this.handleErrorObservable));
    }

    private handleErrorObservable(error: HttpErrorResponse) {
        console.error(error.message || error);
        return observableThrowError(error.message || error);
    }

}
